var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Check component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCheck extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.6223 3.75416C21.9416 4.01802 21.9865 4.49076 21.7227 4.81006L9.46837 19.639L9.46655 19.6412C9.26144 19.8875 9.004 20.085 8.71298 20.2193C8.42196 20.3536 8.10465 20.4214 7.78415 20.4177C7.4584 20.4136 7.13714 20.3358 6.84575 20.1902C6.555 20.0448 6.30087 19.8356 6.10236 19.5782C6.10193 19.5776 6.10151 19.5771 6.10108 19.5765L2.26251 14.6412C2.00821 14.3143 2.06711 13.843 2.39407 13.5887C2.72103 13.3344 3.19224 13.3933 3.44654 13.7203L7.28978 18.6616C7.3503 18.7402 7.42783 18.8041 7.51657 18.8485C7.60532 18.8929 7.70296 18.9166 7.80217 18.9178C7.89956 18.9188 7.99596 18.8982 8.08439 18.8574C8.17269 18.8166 8.25083 18.7568 8.31318 18.6822C8.31342 18.6819 8.31366 18.6816 8.3139 18.6813L20.5664 3.85454C20.8302 3.53524 21.303 3.4903 21.6223 3.75416Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCheck.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCheck.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCheck.prototype, "size", void 0);
if (customElements.get('cat-icon-check') === undefined) {
    customElements.define('cat-icon-check', BlocksIconCheck);
}
